"use client";

import { useMemo, useState } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@leabankab/component-library";
import { PayloadPreview } from "@/components/form/payload-preview";
import { useStepPayloadPreviewContext } from "@/components/form/step-payload-preview-context";
import { useSubmitTask } from "@/hooks";
import { renderByProcess } from "@/shared/render-by-process";
import { TaskType } from "@/types";
import CreditStart from "./components/credit-start";
import LoanStart from "./components/loan-start";
import {
	CreditCardStartInformationContext,
	LoanStartInformationContext,
	LoanStartInformationOfferType,
	StartInformationContext,
} from "./types";

interface Props {
	context: StartInformationContext;
	taskId: string;
}

const StartInformationPage = ({ context, taskId }: Props) => {
	const t = useTranslations("pages.StartInformationPage");
	const flowPayload = useStepPayloadPreviewContext();
	const [offer, setOffer] = useState<
		LoanStartInformationOfferType | undefined
	>();

	const submit = useSubmitTask({
		taskId,
		processType: context.process,
		taskType: TaskType.StartInformation,
	});

	const campaignId = useMemo(() => {
		try {
			const matches = window.location.href.match(/utm_campaign=([^&?#]+)/g);
			if (!matches) {
				return undefined;
			}

			const lastMatch = matches[matches.length - 1];
			return decodeURIComponent(lastMatch.replace("utm_campaign=", ""));
		} catch {
			return undefined;
		}
	}, []);

	const submitBody = useMemo(
		() => ({
			application: {
				campaignId,
			},
			selectedOffer: offer,
		}),
		[campaignId, offer]
	);

	const onSubmit = async () => {
		console.info("StartInformation submit body", submitBody);

		await submit(submitBody);
	};

	return (
		<>
			{renderByProcess<
				LoanStartInformationContext,
				CreditCardStartInformationContext
			>(context, {
				loan: (ctx) => <LoanStart {...ctx} {...{ setOffer }} />,
				credit: (ctx) => <CreditStart {...ctx} />,
			})}

			<Button onClick={onSubmit} className="w-full">
				{t("buttonText")}
			</Button>
			<PayloadPreview flowPayload={flowPayload} payload={submitBody} />
		</>
	);
};

export default StartInformationPage;
